module.exports = __webpack_public_path__ + "img/64.ec3d3f25.jpg";